import React, { useEffect, useState } from 'react'
import { Table, Flex } from 'antd';
import Main from '../../cpn/Main';
import AccountEdit from './AccountEdit';    
import AccountAdd from './AccountAdd';
import { useQiyeyhzhListQuery } from '../../store/DianShangYeWuApi';
import classes from '../system.module.css';
function AccountList(props) {
    const [list, setList] = useState();    
    const qy_id = props.qy_id
    const qy_name = props.qy_name   
    const yh_id = props.yh_id
    const yh_name = props.yh_name
    const {data, isSuccess} = useQiyeyhzhListQuery({qyyhzh_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {qyyhzh_id:key,qyyhzh_name,qyyhzh_full_name,qyyhzh_code,qyyhzh_firm,qyyhzh_content,qyyhzh_uname,qyyhzh_ctime,qyyhzh_update_time,qyyhzh_update_uname,qyyhzh_qc_amount,qyyhzh_qc_date} = item;                 
                    return item = {key,qyyhzh_name,qyyhzh_full_name,qyyhzh_code,qyyhzh_firm,qyyhzh_content,qyyhzh_uname,qyyhzh_ctime,qyyhzh_update_time,qyyhzh_update_uname,qyyhzh_qc_amount,qyyhzh_qc_date}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.qyyhzh_ctime;
                    let bTimeString = b.qyyhzh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'qyyhzh_name',           
            title: '账户简称',            
            dataIndex: 'qyyhzh_name',
            render: (_, record) => {
                return <AccountEdit
                            qyyhzh_id={record.key}    
                            qyyhzh_name={record.qyyhzh_name} 
                            qyyhzh_full_name={record.qyyhzh_full_name} 
                            qyyhzh_code={record.qyyhzh_code} 
                            qyyhzh_firm={record.qyyhzh_firm} 
                            qyyhzh_content={record.qyyhzh_content} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                            qyyhzh_ctime={record.qyyhzh_ctime}
                            qyyhzh_update_time={record.qyyhzh_update_time}
                            qyyhzh_uname={record.qyyhzh_uname}
                            qyyhzh_update_uname={record.qyyhzh_update_uname}
                        />
            }
        },              
        {
            key: 'qyyhzh_full_name',           
            title: '账户全称',            
            dataIndex: 'qyyhzh_full_name',
        },              
        {
            key: 'qyyhzh_code',           
            title: '银行账号',            
            dataIndex: 'qyyhzh_code',
        },              
        {
            key: 'qyyhzh_firm',           
            title: '开户银行',            
            dataIndex: 'qyyhzh_firm',
        },              
        {
            key: 'qyyhzh_content',           
            title: '备注',            
            dataIndex: 'qyyhzh_content',
        },                    
        {
            key: 'qyyhzh_qc_amount',           
            title: '期初金额',            
            dataIndex: 'qyyhzh_qc_amount',
        },                      
        {
            key: 'qyyhzh_qc_date',           
            title: '期初日期',            
            dataIndex: 'qyyhzh_qc_date',
        },                      
        {
            key: 'key',           
            title: '编号',            
            dataIndex: 'key',
        },   
    ]   
    return (
        <Main 
            selectedKeys={['/AccountList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            reportEndNeedReadNum={props.reportEndNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
            yh_qx={props.yh_qx}
            userList={props.userList}
            deptList={props.deptList}
        >                       
            <Flex justify='flex-end'>
                <AccountAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default AccountList
